import React from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import LogosMarquee from '@/components/LogosMarquee';
import FeaturesSection from '@/components/FeaturesSection';
import SystemOverviewSection from '@/components/SystemOverviewSection';
import UseCasesSection from '@/components/UseCasesSection';
import TrustSection from '@/components/TrustSection';
import PricingSection from '@/components/PricingSection';
import FaqSection from '@/components/FaqSection';
import FinalCTA from '@/components/FinalCTA';
import Footer from '@/components/Footer';

export default function LandingPage() {
  return (
    <div className="bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <HeroSection />
        <LogosMarquee />
        <FeaturesSection />
        <SystemOverviewSection />
        <UseCasesSection />
        <TrustSection />
        <PricingSection />
        <FaqSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
